import {
  polls_poll_order_read,
  polls_poll_order_update,
} from "@/lib/api-client.js";
import { getAxiosConfigNoAuth as axconfNoAuth } from "@/lib/api-config.js";

export default {
  namespaced: true,
  state: {},
  actions: {
    LOAD_POLL: (undefined, payload) => {
      var config = axconfNoAuth();
      return new Promise((resolve, reject) => {
        polls_poll_order_read({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          pollId: payload.pollId,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    UPDATE_POLL: (undefined, payload) => {
      var config = axconfNoAuth();
      return new Promise((resolve, reject) => {
        polls_poll_order_update({
          data: payload.data,
          pollId: payload.pollId,
          role: "vooyguest",
          roleUuid: "1",
          $config: config,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
  },
  mutations: {
  },
  getters: {
  },
};
